import { render, staticRenderFns } from "./PricingOptionText.vue?vue&type=template&id=0b52a1e4&scoped=true&"
import script from "./PricingOptionText.vue?vue&type=script&lang=js&"
export * from "./PricingOptionText.vue?vue&type=script&lang=js&"
import style0 from "./PricingOptionText.vue?vue&type=style&index=0&id=0b52a1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52a1e4",
  null
  
)

export default component.exports